import React from "react"
import AccountPhoto from "./AccountPhoto"
import PhotoModal from "./PhotoModal"

class Account extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      loading: false,
      message: "",
      percent: "",
      isHidden: false,
      isDraggable: false,
      modalOpen: false,
      currentPhotoIndex: null,
      accountMode: this.props.account.mode || 'auto_x6',
      isMobile: window.innerWidth <= 768
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 768 });
  }

  generateColorFromName(name) {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = hash % 360;
    return `hsl(${hue}, 70%, 25%)`;
  }

  getInitial(nickname) {
    return nickname ? nickname.charAt(0).toUpperCase() : '?';
  }

  handleAvatarError() {
    this.setState({avatar: null});
  }

  remove(id) {
    if (confirm('Удалить этот аккаунт?')) {
      this.setState({ isHidden: true });
      $.ajax({
        url: "/accounts/" + id,
        headers: { 'Content-Type': 'application/json' },
        type: 'DELETE',
        success: function(result) {
          console.log("deleted!");
        }
      });
    }
  }

  updateMode = (e) => {
    const newMode = e.target.value;
    this.setState({ accountMode: newMode });
    
    $.ajax({
      url: "/accounts/" + this.props.account.id,
      headers: { 
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      type: 'PUT',
      data: JSON.stringify({ account: { mode: newMode } }),
      success: function(result) {
        console.log("mode updated to " + newMode);
      }
    });
  }

  openModal = (photoId) => {
    const index = this.props.account.media_items.findIndex(item => item.id === photoId);
    this.setState({
      modalOpen: true,
      currentPhotoIndex: index
    });
    document.body.style.overflow = 'hidden';
  }

  closeModal = () => {
    this.setState({
      modalOpen: false,
      currentPhotoIndex: null
    });
    document.body.style.overflow = 'auto';
  }

  navigatePhoto = (direction) => {
    const { media_items } = this.props.account;
    
    this.setState(prevState => {
      let newIndex = prevState.currentPhotoIndex + direction;
      
      if (newIndex < 0) {
        newIndex = media_items.length - 1;
      } else if (newIndex >= media_items.length) {
        newIndex = 0;
      }
      
      return { currentPhotoIndex: newIndex };
    });
  }

  render() {
    if (this.state.isHidden) {
      return null;
    }

    const { isMobile } = this.state;
    let el = this.props.account;
    const accountPhotos = this.props.account.media_items.map((media_item) => (
      <AccountPhoto 
        key={media_item.id} 
        data={media_item}
        onPhotoClick={this.openModal}
      />
    ));

    const backgroundColor = this.generateColorFromName(el.nickname);

    return (
      <div className="bg-slate-900/95 backdrop-blur-sm rounded-lg shadow-lg border border-slate-800/50 flex flex-col h-full">
        {/* Account Header */}
        <div className="p-4 flex-shrink-0">
          <div className={`flex flex-col space-y-4`}>
            {/* Top row with avatar, username, metadata and delete button */}
            <div className={`flex ${isMobile ? 'flex-col space-y-4' : 'items-center justify-between'}`}>
              {/* Left side - avatar and metadata */}
              <div className="flex items-center space-x-4 min-w-0">
                {/* Avatar section */}
                <div className="relative flex-shrink-0">
                  {!el.parsed && (
                    <div className="absolute -inset-1">
                      <svg className="w-14 h-14 animate-slow-spin" viewBox="0 0 50 50">
                        <circle
                          cx="25"
                          cy="25"
                          r="23"
                          fill="none"
                          stroke="rgba(52, 211, 153, 0.1)"
                          strokeWidth="2"
                          strokeDasharray="36.13 36.13"
                          strokeDashoffset="0"
                        />
                        <circle
                          cx="25"
                          cy="25"
                          r="23"
                          fill="none"
                          stroke="rgba(52, 211, 153, 0.6)"
                          strokeWidth="2"
                          strokeDasharray="36.13 108.39"
                          strokeDashoffset="0"
                        />
                      </svg>
                    </div>
                  )}
                  {el.avatar && el.avatar.url ? (
                    <img 
                      src={el.avatar.url} 
                      className={`relative rounded-full object-cover ring-2 ring-slate-700/50 ${isMobile ? 'w-16 h-16' : 'w-12 h-12'}`}
                      onError={this.handleAvatarError.bind(this)}
                    />
                  ) : (
                    <div 
                      className={`relative rounded-full ring-2 ring-slate-700/50 flex items-center justify-center text-lg font-medium text-white ${isMobile ? 'w-16 h-16' : 'w-12 h-12'}`}
                      style={{ backgroundColor }}
                    >
                      {this.getInitial(el.nickname)}
                    </div>
                  )}
                  <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-emerald-500 rounded-full border-2 border-slate-900"></div>
                </div>

                {/* Username and stats */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 min-w-0">
                  <a href={`https://instagram.com/${el.nickname}`} 
                     target="_blank"
                     className="text-slate-200 hover:text-blue-400 font-medium text-lg truncate">
                    {el.nickname}
                  </a>
                  
                  <div className="flex items-center space-x-4 text-sm mt-2 sm:mt-0">
                    <div className="flex flex-col items-center">
                      <span className="font-medium text-slate-200">{el.publications}</span>
                      <span className="text-slate-400 text-xs">публикаций</span>
                    </div>
                    <div className="flex flex-col items-center">
                      <span className="font-medium text-slate-200">{el.subscribers}</span>
                      <span className="text-slate-400 text-xs">подписчиков</span>
                    </div>
                    <div className="flex flex-col items-center">
                      <span className="font-medium text-slate-200">{el.subscriptions}</span>
                      <span className="text-slate-400 text-xs">подписок</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right side - mode selector and delete button */}
              <div className="flex items-center space-x-4">
                <div className="flex items-center space-x-2 mr-2">
                  <span className="text-xs text-slate-400">Режим:</span>
                  <select 
                    value={this.state.accountMode} 
                    onChange={this.updateMode}
                    className="bg-slate-800 border border-slate-700 text-slate-200 text-xs rounded p-1 focus:ring-1 focus:ring-blue-500 focus:outline-none"
                  >
                    <option value="auto_x6">Авто-X6</option>
                    <option value="manual">Ручной</option>
                  </select>
                </div>
                {!isMobile && (
                  <div className="text-slate-500 text-xs self-center">
                    Обновлено {el.updated_at}
                  </div>
                )}
                <button
                  onClick={() => this.remove(el.id)}
                  className="p-1.5 text-red-400 hover:text-red-300 hover:bg-red-500/10 rounded-lg transition-colors flex-shrink-0"
                >
                  <i className="fas fa-trash"></i>
                </button>
              </div>
            </div>

            {/* Last Updated - Only visible on mobile */}
            {isMobile && (
              <div className="text-slate-500 text-xs text-center">
                Обновлено {el.updated_at}
              </div>
            )}
          </div>
        </div>

        <div className={`grid sm:gap-1 gap-0 sm:px-4 px-0 ${
          isMobile 
            ? 'grid-cols-2' 
            : 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6'
        }`}>
          {accountPhotos}
        </div>

        {/* Modal */}
        {this.state.modalOpen && this.state.currentPhotoIndex !== null && (
          <PhotoModal 
            photo={this.props.account.media_items[this.state.currentPhotoIndex]}
            account={el}
            onClose={this.closeModal}
            onNavigate={this.navigatePhoto}
            isMobile={isMobile}
          />
        )}

        {/* View More Button */}
        {this.props.account.media_items.length > 0 && !window.location.pathname.includes('/accounts/') && (
          <div className="mt-6 p-4 bg-slate-800/50">
            <div className="flex justify-center">
              <a href={`/accounts/${el.id}`}
                 className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-3 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-colors text-sm font-medium shadow-lg hover:shadow-xl">
                <i className="fas fa-th-large mr-2.5"></i>
                Просмотреть все медиа
              </a>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Account;